import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Search, Package, MapPin, Clock } from "lucide-react";
import { shipmentService } from "@/services/shipmentService";
import { trackingHistoryService } from "@/services/trackingHistoryService";

export default function TrackShipmentPage() {
  const { trackingNumber: urlTrackingNumber } = useParams();
  const [trackingNumber, setTrackingNumber] = useState(urlTrackingNumber || "");

  // تحديث الحقل تلقائياً إذا تغير الرابط
  useEffect(() => {
    if (urlTrackingNumber && urlTrackingNumber !== trackingNumber) {
      setTrackingNumber(urlTrackingNumber);
    }
  }, [urlTrackingNumber]);

  const { data: shipmentResponse } = useQuery({
    queryKey: ["shipment", trackingNumber],
    queryFn: () => shipmentService.getByTracking(trackingNumber),
    enabled: !!trackingNumber && trackingNumber.length > 0,
  });

  const { data: historyResponse } = useQuery({
    queryKey: ["trackingHistory", shipmentResponse?.data?.id],
    queryFn: () => trackingHistoryService.getByShipmentId(shipmentResponse!.data!.id),
    enabled: !!shipmentResponse?.data?.id,
  });

  const shipment = shipmentResponse?.data;
  const history = historyResponse?.data || [];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">تتبع الشحنة</h1>
      <Card>
        <CardContent className="pt-6">
          <div className="flex gap-2">
            <Input placeholder="ادخل رقم التتبع" value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} />
            <Button><Search className="w-4 h-4" /></Button>
          </div>
        </CardContent>
      </Card>
      {shipment && (
        <Card>
          <CardHeader><CardTitle className="flex items-center gap-2"><Package className="w-5 h-5" />معلومات الشحنة</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div><p className="text-sm text-gray-500">رقم التتبع</p><p className="font-bold">{shipment.trackingNumber}</p></div>
              <div><p className="text-sm text-gray-500">الحالة</p><p className="font-bold">{shipment.statusId}</p></div>
              <div><p className="text-sm text-gray-500">المرسل</p><p>{shipment.senderName}</p></div>
              <div><p className="text-sm text-gray-500">المستلم</p><p>{shipment.receiverName}</p></div>
            </div>
          </CardContent>
        </Card>
      )}
      {history.length > 0 && (
        <Card>
          <CardHeader><CardTitle className="flex items-center gap-2"><Clock className="w-5 h-5" />سجل التتبع</CardTitle></CardHeader>
          <CardContent>
            <div className="space-y-4">
              {history.map((h: any) => (
                <div key={h.id} className="flex items-start gap-3 pb-4 border-b last:border-0">
                  <MapPin className="w-5 h-5 text-blue-500 mt-1" />
                  <div>
                    <p className="font-medium">{h.status}</p>
                    <p className="text-sm text-gray-500">{h.location}</p>
                    <p className="text-xs text-gray-400">{new Date(h.timestamp).toLocaleString("ar-EG")}</p>
                    {h.notes && <p className="text-sm text-gray-600 mt-1">{h.notes}</p>}
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
